module.exports = __webpack_public_path__ + "static/media/vscode.9921f2b2.jpg";